import { useMemo } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useData } from '../contexts/DataContext';

/**
 * Custom hook that returns the correct user display name
 * Prioritizes staff data over Supabase Auth displayName for consistency
 */
export const useUserDisplayName = () => {
  const { user } = useAuth();
  const { staff } = useData();
  
  const displayName = useMemo(() => {
    if (!user) return 'Unknown User';
    
    // Try to find the user in staff data first for most accurate name
    const currentStaff = staff.find(s => s.email === user.email);
    
    // Prioritize staff data fullName, then name, then fallback to Supabase Auth
    return currentStaff?.fullName || 
           currentStaff?.name || 
           user.displayName || 
           user.email?.split('@')[0] || 
           'Unknown User';
  }, [user, staff]);
  
  return displayName;
};